import { useLocation, useNavigate } from 'react-router-dom'
import { Megaphone } from 'lucide-react'
import { cn } from '@/lib/utils'
import { usePendingFeedbackPrompts } from '@/hooks/use-feedback'

interface FeedbackHeaderButtonProps {
  /** Header chrome icon button styling from App.tsx. */
  buttonClassName?: string
}

/**
 * Icon-only shortcut to the feedback board with a badge for team-authored
 * prompts the user hasn't answered or dismissed yet.
 */
export function FeedbackHeaderButton({ buttonClassName }: FeedbackHeaderButtonProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { prompts } = usePendingFeedbackPrompts()
  const pendingCount = prompts.length

  return (
    <button
      type="button"
      className={cn('relative', buttonClassName)}
      title="Feedback"
      aria-label={
        pendingCount > 0
          ? `Feedback (${pendingCount} pending ${pendingCount === 1 ? 'prompt' : 'prompts'})`
          : 'Feedback'
      }
      onClick={() =>
        navigate('/feedback', {
          state: { from: `${location.pathname}${location.search}` },
        })
      }
    >
      <Megaphone className="h-4 w-4 shrink-0" />
      {pendingCount > 0 && (
        <span
          aria-hidden
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-semibold leading-none text-destructive-foreground"
        >
          {pendingCount > 9 ? '9+' : pendingCount}
        </span>
      )}
    </button>
  )
}
